// extracted by mini-css-extract-plugin
module.exports = {"auth":"index_auth_3rFeQ","container":"index_container_nRfm-","googleSign":"index_googleSign_3Js9Z","footerNav":"index_footerNav_fgOEa"};